export const loadJS = url =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.crossorigin = 'true';

    if (script.readyState) {
      script.onreadystatechange = () => {
        if (['loaded', 'complete'].includes(script.readyState)) {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      script.onload = resolve;
    }

    script.onerror = reject;
    script.src = url;
    document.body.append(script);
  });

export const onFontsReady = async callback => {
  await document.fonts.ready;
  callback();
};
